export default __webpack_public_path__ + "static/media/contact.da42c69b.mp4";